
import './App.scss';
import Home from "./Pages/home.jsx"
import Privacy from './Section/privacy/Privacy.jsx';
import { FloatingWhatsApp } from 'react-floating-whatsapp';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";


function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/privacy-policy" element={<Privacy />} />
      </Routes>
      <a
        target="_blank"
        href="https://api.whatsapp.com/send/?phone=6282386303140&text=Halo%20Mario,%20Saya%20bisa%20minta%20detail%20Katalog,%20Simulasi,%20dan%20Promo%20terbaru%20Produk%20The%20Mutiara%20Bogor%20https://marketingthemutiarabogor.id//&type=phone_number&app_absent=0"
      >
        <FloatingWhatsApp />
      </a>
    </Router>
  );
}

export default App;